import React from 'react';
import styled from 'react-emotion';
import useCleanProps from '../../../hooks/useCleanProps';
import MaxWidth from '../../Layout/MaxWidth';
import { Linker } from '../../ui/Linker';
import { ReactComponent as Caret } from '../../../svg/Carrot.svg';


const StyledMaxWidth = styled(MaxWidth)`

    div {
        width: 100%;
        
    }
    
  &.narrow {
      
      div {
            margin: 0 auto;
          max-width: 60rem;
      }
      
  }
    
    a {
        display: inline-flex;
        align-items: center;
        
        svg {
            width: 0.75rem;
            height: 0.75rem;
            margin: 0  0.125rem 0 0;
            transform: rotate(-90deg);
        }
        
        span + svg {
            width: 1rem;
            height: 1rem;
            margin: 0 0 0 0.125rem;
            
        }
        
    }
    
`;

const SingleLink = props => {
  const {
    linkUrl,
    linkText,
    asButton,
    fullWidth,
    spaceAbove = '16px'
  } = useCleanProps(props);

  if (!props) return null;

  return (
    <StyledMaxWidth
      className={`${fullWidth ? 'full-width' : 'narrow'}`}
      style={{ marginTop: spaceAbove }}
    >
      <div>
        <Linker to={linkUrl} type={asButton ? 'button-cta' : 'inline'}>
          {!asButton && <Caret />}
          <span>{linkText}</span>
          {asButton && <Caret />}
        </Linker>
      </div>
    </StyledMaxWidth>
  );
};

export default SingleLink;
